module.exports = "//static.hsappstatic.net/collaboration-sidebar/static-1.16571/images/CommentIndicatorPointerFlint.svg"